<script>
import appConfig from '@/app.config'
import PageHeader from '@/components/page-header-v2'
import Layout from '@/router/layouts/main'
import moment from 'moment'
import Swal from 'sweetalert2'
import { Helper } from '@/mixin/helper'
import * as CompanyCode from '@/services/rest-api/lib/setting/company-code'
import {
  GET_COMPANY_CATEGORIES,
  GET_COMPANY_PROFILE,
  UPDATE_COMPANY_PROFILE,
  CREATE_COMPANY_CATEGORIES,
} from '@/services/api/setting/company/profile'
import { mapGetters } from 'vuex'
import McButton from '@/components/McButton'
moment.locale('id')
import AddressList from './AddressList'
import BankList from './BankList'
import ModalAddBank from './ModalAddBank'
import ModalAddLogo from './ModalAddLogo'
/**
 * Starter component
 */
export default {
  page: {
    title: 'Setting',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
    McButton,
    AddressList,
    BankList,
    ModalAddBank,
    ModalAddLogo,
  },
  mixins: [Helper],
  apollo: {
    company: {
      query: GET_COMPANY_PROFILE,
      variables() {
        return {
          filter: {
            id: this.companyId,
          },
        }
      },
      result({ data, loading }) {
        if (!loading) {
          if (!data.company.isSuccessful) {
            this.$mcToast.warning(data.company.message)
          }
          this.initEditPage(data.company.company)
        }
      },
      manual: true,
      fetchPolicy: 'no-cache',
    },
  },
  data() {
    return {
      companyId: null,
      companyCategories: {
        companyCategories: [],
      },
      company: {
        company: [],
      },
      currentDate: new Date(),
      formOld: {},
      formEdit: false,
      form: {
        name: null,
        email: null,
        phoneNo: null,
        faxNo: null,
        taxNo: null,
        category: null,
        companyTag: null,
        logoUrl: '',
        photo: '',
        photoExt: '',
        bankAccounts: [],
      },
      deleteAddress: [],
      isUnique: true,
      tData: [],
      imagePreview: null,
      loading: false,
      isFileError: false,
      isActiveOpen: false,
      showRemovedBtn: false,
      importResponse: false,
      isUpload: false,
      companyCode: null,
      fullObject: {
        companyCategories: {},
      },
      fileProp: {
        name: null,
        progressVal: 0,
        size: 0,
        sizeProgress: 0,
        error: false,
        message: null,
      },
      isLoading: true,
    }
  },

  computed: {
    title() {
      return this.$t('setting.list.company.title')
    },
    subTitle() {
      return this.$t('setting.list.company.description')
    },
    totalTrue() {
      let count = 0
      for (let i = 0; i < this.tData.length; i++) {
        if (this.tData[i].isDefault) {
          count++
        }
      }
      return count
    },
    ...mapGetters({
      hasAccess: 'identity/hasAccess',
      hasAccessAll: 'identity/hasAccessAll',
    }),
    disableCompanyCodeCopy() {
      return this.companyCode === null
    },
    showCompanyCodeSection() {
      return this.hasAccessAll(['tms:create', 'tms:read', 'tms:update', 'tms:delete'])
    },
    resourcefulQuery() {
      return {
        companyCategories: async (opts) => {
          let result = {}
          let companyCategories = []

          const res = await this.$apollo.query({
            query: GET_COMPANY_CATEGORIES,
          })
          companyCategories = res.data.companyCategories.companyCategories

          if (opts.search)
            companyCategories = companyCategories.filter((item) =>
              item.name.toLowerCase().includes(opts.search.toLowerCase())
            )

          result = {
            metadata: {
              total_count: 5,
              page: 1,
            },
            data: {
              paginated_result: companyCategories,
            },
          }

          return result
        },
      }
    },
    breadcrumbItems() {
      return [
        {
          text: this.$t('setting.homePage.pengaturan'),
          to: '/setting',
        },
        {
          text: this.$t('setting.list.company.title'),
        },
      ]
    },
  },

  watch: {
    'form.category': {
      deep: true,
      handler(value) {
        this.fullObject.companyCategories = {
          text: value,
        }
      },
    },
  },

  mounted() {
    this.companyId = this.getCompanyId()
    this.$apollo.queries.company.refetch()
    this.getCompanyCode()
  },
  methods: {
    initEditPage(item) {
      this.isLoading = true
      this.formOld = item
      this.form.name = item.name
      this.form.logoUrl = item.logoUrl
      this.form.email = item.email
      this.form.phoneNo = item.phoneNo
      this.form.faxNo = item.faxNo
      this.form.taxNo = item.taxNo
      this.form.category = item.category
      this.form.companyTag = item.companyTag
      this.form.photo = item.photo
      this.form.photoExt = item.photoExt
      this.imagePreview = item.logoUrl || require(`@/assets/images/default-image-user.png`)
      let banks = item.bankAccounts || []
      let resBanks = []
      banks.forEach(function (item) {
        resBanks.push({
          ...item,
        })
      })
      this.form.bankAccounts = resBanks
      this.tData = item.bankAccounts
      setTimeout(() => {
        this.isLoading = false
      }, 500)
    },

    async getCompanyCode() {
      const res = await CompanyCode.show()

      if (res.errors) {
        this.$mcToast.error(this.$t('setting.list.company.form.companyCodeFetchError'))
        return
      }

      this.companyCode = res.data
      this.isLoading = false
    },
    async copyCompanyCode() {
      navigator.clipboard.writeText(this.companyCode)
      this.$mcToast.success(this.$t('setting.list.company.form.companyCodeCopySuccess'))
    },

    clearDelete(field) {
      if (field == 'address') {
        this.filterAddressSelected = []
        this.selectAllAddress = false
      } else if (field == 'bank') {
        this.filterBankSelected = []
        this.selectAllbank = false
      }
      this.$apollo.queries.company.refetch()
    },
    addOptions(newTag) {
      const tag = {
        text: newTag,
      }

      this.form.category = newTag
      this.$apollo
        .mutate({
          mutation: CREATE_COMPANY_CATEGORIES,
          variables: {
            input: tag,
          },
        })
        .then((response) => {
          if (response.data.createCompanyCategory.isSuccessful) {
            this.$apollo.queries.companyCategories.refetch()
          }
        })
    },

    deleteLogo() {
      this.$mcToast.error(this.$t('global.alert.text.logoDeleted'))
    },
    onFileChange(e) {
      this.isUpload = true
      const file = e.target.files[0]
      let photoExt = file['type'].replace('image/', '')
      let acceptedFile = ['jpeg', 'jpg', 'png']
      if (!acceptedFile.includes(photoExt)) {
        this.isFileError = true
        return
      }

      this.fileProp.name = file['name']
      let size = file['size']
      if (size >= 2048000) {
        this.isFileError = true
        return
      }
      this.form.logoUrl = URL.createObjectURL(file)
      this.imagePreview = this.form.logoUrl
      const reader = new FileReader()
      reader.onloadend = () => {
        this.form.photo = reader.result.split(',')[1]
      }

      this.isFileError = false
      const param = [15, 25, 50, 70, 90, 100]
      for (let i = 0; i < param.length; i++) {
        setTimeout(() => {
          this.fileProp.sizeProgress = ((this.fileProp.size * param[i]) / 100).toFixed(2)
          this.fileProp.progressVal = param[i]
          if (param[i] === 100) {
            setTimeout(() => {
              this.form.photo = reader.readAsDataURL(file)
              this.form.photoExt = file['type'].replace('image/', '')
              this.isUpload = false
            }, 1000)
          }
        }, i * 500)
      }
    },

    checkChanged() {
      let isChanged = false
      let forms = this.form
      let formsOld = this.formOld
      let excepts = ['companyTag', 'photo', 'photoExt', 'bankAccounts']
      Object.keys(this.form).forEach(function (key) {
        if (!excepts.includes(key)) {
          if (forms[key] != formsOld[key]) {
            isChanged = true
          }
        }
      })
      return isChanged
    },
    resetModal() {
      this.bankAccounts = []
      this.deleteAddress = []
      this.formEdit = false
      this.isUnique = true
    },
    toCancel() {
      let isEmpty = !this.checkChanged()
      if (isEmpty) {
        this.$router.push({ name: 'Setting' })
      } else {
        Swal.fire({
          title: this.$t('global.alert.text.cancel'),
          text: this.$t('global.alert.text.confirmCancel'),
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: this.$t('global.yes'),
          cancelButtonText: this.$t('global.no'),
        }).then((result) => {
          if (result.value) {
            this.$router.push({ name: 'Setting' })
          }
        })
      }
    },

    toSave() {
      let bankAccounts = []
      if (this.tData.length > 0) {
        this.tData.forEach(function (item) {
          bankAccounts.push({
            bankName: item.bankName,
            accountName: item.accountName,
            accountNo: item.accountNo,
            isDefault: item.isDefault || false,
          })
        })
      }
      let photoObject = {}
      if (this.form.photo != '' && this.form.photo != null) {
        photoObject = {
          logoUrl: this.form.logoUrl,
          photo: this.form.photo,
          photoExt: this.form.photoExt,
        }
      }

      let input = {
        id: this.companyId,
        name: this.form.name,
        email: this.form.email,
        phoneNo: this.form.phoneNo,
        faxNo: this.form.faxNo,
        taxNo: this.form.taxNo,
        category: this.form.category ?? null,
        companyTag: this.form.companyTag,
        bankAccounts: bankAccounts,
        ...photoObject,
      }

      this.$apollo
        .mutate({
          mutation: UPDATE_COMPANY_PROFILE,
          variables: {
            input: input,
          },
        })
        .then((response) => {
          if (response.data.updateCompany.isSuccessful) {
            this.$mcToast.success(this.$t('global.alert.text.saved'))
            this.$apollo.queries.company.refetch()
          } else {
            this.$mcToast.warning(response.data.updateCompany.message)
          }
        })
    },
    submitForm() {
      this.$refs.formRef.formSubmitted()
    },
    toSaveBank(value) {
      if (value.isDefault) {
        for (let i = 0; i < this.tData.length; i++) {
          this.tData[i].isDefault = false
        }
      }
      if (this.formEdit) {
        this.tData.splice(this.bankIndex, 1, {
          bankName: value.bankName,
          accountName: value.accountName,
          accountNo: value.accountNo,
          isDefault: value.isDefault || false,
        })
      } else {
        this.tData.push({
          bankName: value.bankName,
          accountName: value.accountName,
          accountNo: value.accountNo,
          isDefault: value.isDefault || false,
        })
      }
      this.submitForm()
      this.form.bankAccounts = []
      this.$bvModal.hide('addBank')
    },

    updateDelete(value) {
      this.deleteAddress = value
    },
    updateOnChange(value) {
      this.onFileChange(value)
    },
    deleteFile() {
      this.importResponse = false
      this.file = null

      this.fileProp = {
        name: null,
        size: 0,
        sizeProgress: 0,
        message: null,
        error: false,
        progressVal: 0,
      }
    },
  },
}
</script>

<template>
  <Layout>
    <PageHeader
      :title="title"
      :subTitle="subTitle"
      :items="breadcrumbItems"
      hasBreadcrumb
      hasBackButton
    >
      <template #afterTitle>
        <div>
          <McButton
            variant="secondary"
            class="mx-2"
            icon="icon-fill_close"
            :text="$t('global.cancel')"
            @click="toCancel"
          />
          <McButton
            variant="primary"
            icon="icon-outline_save"
            :text="$t('global.save')"
            :disabled="isFileError || isUpload"
            @click="submitForm"
          />
        </div>
      </template>
    </PageHeader>

    <div class="mc-form">
      <h4 class="card-title">
        {{ $t('setting.list.company.info') }}
      </h4>
      <FormulateForm ref="formRef" v-model="form" @submit="toSave">
        <b-card>
          <b-row>
            <b-col sm="12" md="6">
              <b-row>
                <b-col md="3">
                  <div class="d-flex justify-content-center mb-2">
                    <img
                      :src="imagePreview"
                      alt
                      class="avatar-lg rounded-circle img-thumbnail"
                      style="object-fit: cover"
                    />
                  </div>
                </b-col>
                <b-col md="9">
                  <div class="mc-input-info">
                    <FormulateInput
                      id="formFile"
                      type="image-input"
                      :isFileError="isFileError"
                      :onFileChange="onFileChange"
                      :validationText="$t('setting.list.company.formAlert.logoFormat')"
                    >
                      <template #label>
                        <div class="d-flex justify-content-between align-items-center">
                          <label>{{ $t('setting.list.company.form.logo') }} </label>
                          <span id="tooltip-info" class="mc-input-info__btn">
                            <i class="bx bx-info-circle" />
                          </span>
                        </div>
                        <b-tooltip target="tooltip-info" triggers="click" placement="leftbottom">
                          <ul>
                            <li>{{ 'Format (.jpg / .png)' }}</li>
                            <li>{{ $t('setting.list.company.formAlert.logoLimit') }}</li>
                          </ul>
                        </b-tooltip>
                      </template>
                    </FormulateInput>
                  </div>
                </b-col>
              </b-row>
            </b-col>
            <b-col sm="12" md="6">
              <FormulateInput
                id="name"
                validation="required"
                name="name"
                help="required"
                :placeholder="$t('setting.list.company.form.name')"
                :validation-messages="{
                  required: $t('setting.list.company.formAlert.nameCompany'),
                }"
              />
            </b-col>
            <b-col sm="12" md="6">
              <div class="mb-3">
                <FormulateInput
                  id="email"
                  name="email"
                  help="required"
                  :placeholder="$t('notification.setting.emailNotification.email')"
                  validation="required|email"
                  :validation-messages="{
                    required: $t('setting.list.company.formAlert.email'),
                    email: $t('setting.list.company.formAlert.emailFormat'),
                  }"
                />
              </div>
            </b-col>
            <b-col sm="12" md="6">
              <div class="mb-3">
                <FormulateInput
                  id="phone_no"
                  name="phoneNo"
                  :placeholder="$t('setting.list.company.form.phoneNo')"
                  :label="$t('setting.list.company.form.phoneNo')"
                  class="masking-number"
                  validation="number"
                />
              </div>
            </b-col>
            <b-col sm="12" md="3">
              <div class="mb-3">
                <FormulateInput
                  id="fax"
                  name="faxNo"
                  :placeholder="$t('setting.list.company.form.faxNo')"
                  :label="$t('setting.list.company.form.faxNo')"
                  validation="number"
                  @keypress="isNumber($event)"
                />
              </div>
            </b-col>
            <b-col sm="12" md="3">
              <div class="mb-3">
                <FormulateInput
                  id="npwp"
                  name="taxNo"
                  label="NPWP"
                  placeholder="NPWP"
                  validation="number"
                  @keypress="isNumber($event)"
                />
              </div>
            </b-col>
            <b-col sm="12" md="3">
              <div class="mb-3">
                <FormulateInput
                  v-model="form.category"
                  type="select-resourceful-v2"
                  name="category"
                  :placeholder="$t('setting.list.company.form.industryCategory')"
                  :label="$t('setting.list.company.form.industryCategory')"
                  :trackBy="'text'"
                  :optionsGetter="resourcefulQuery.companyCategories"
                  :optionLabelFn="({ item }) => item.text"
                  :fullObject="fullObject.companyCategories"
                  :multiple="false"
                  :taggable="true"
                  tabIndex="0"
                  @addTag="addOptions"
                />
              </div>
            </b-col>
            <b-col v-if="showCompanyCodeSection" sm="12" md="3">
              <div class="mb-3">
                <div class="mc-readonly col">
                  <div class="d-flex justify-content-between">
                    <div class="mb-2 teal-300">
                      {{ $t('setting.list.company.form.companyCode') }}
                    </div>
                    <span
                      v-b-tooltip.topleft
                      :title="$t('setting.list.company.form.companyCodeTooltip')"
                    >
                      <i class="mc-fa icon-outline_info" />
                    </span>
                  </div>
                  <div class="d-flex align-items-center w-100">
                    <div class="flex-grow-1 company-code">
                      {{ companyCode }}
                    </div>
                    <McButton
                      class="ms-2 flex-shrink-0"
                      variant="secondary"
                      size="sm"
                      icon="icon-outline_copy"
                      :text="$t('setting.list.company.form.copyCompanyCode')"
                      :disabled="disableCompanyCodeCopy"
                      @click.prevent="copyCompanyCode"
                    />
                  </div>
                </div>
              </div>
            </b-col>
          </b-row>
        </b-card>
      </FormulateForm>

      <AddressList
        v-if="hasAccess(['geofences:read'])"
        :resetModal="resetModal"
        @updateDelete="updateDelete"
        @clearDelete="clearDelete"
      />

      <div v-if="$store.state.config.mode !== 'production'" class="clearfix mb-3">
        <div class="float-start">
          <h4 class="card-title">
            {{ $t('setting.list.company.form.additionalLogo') }}
          </h4>
        </div>

        <div class="d-flex justify-content-end">
          <McButton
            v-if="hasAccess(['company:update'])"
            v-b-modal.addLogo
            variant="primary"
            icon="icon-outline_plus"
            :text="$t('global.addField')"
          />
        </div>
      </div>

      <b-card v-if="$store.state.config.mode !== 'production'">
        <b-row>
          <b-col md="3">
            <div class="mc-logo-additional">
              <figure>
                <img :src="imagePreview" alt class="avatar-xxl img-thumbnail" />
              </figure>
              <p>{{ $t('setting.list.company.form.logoPhoto') }}</p>
              <i
                v-if="hasAccess(['company:update'])"
                class="mc-fa icon-outline_trash"
                @click="deleteLogo"
              />
            </div>
          </b-col>
        </b-row>
      </b-card>

      <BankList :tData="tData" :resetModal="resetModal" @clearDelete="clearDelete" />
    </div>

    <ModalAddBank
      v-if="!isLoading"
      :tData="tData"
      :resetModal="resetModal"
      :formEdit="formEdit"
      @toSaveBank="toSaveBank"
    />
    <ModalAddLogo :fileProp="fileProp" @updateOnChange="updateOnChange" />
  </Layout>
</template>

<style scoped>
.company-code {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
